import Cookies from 'js-cookie'
import { infoClient } from '~/core/utils/clients/infoClient'
import { CookieKey } from '~/core/enums'

export enum HealthDiariesStatus {
  Assigned = 'assigned',
  HasEntry = 'has_entry',
  Empty = 'empty'
}

export type HealthDiaryStateDTO = {
  diaryStatus: HealthDiariesStatus
}
const RESOURCE = '/health_diaries'
export const HealthDiariesApi = {
  getState(familyProfileUuid?: string) {
    const headers: Record<string, string> = {
      'Medcard-Token': Cookies.get(CookieKey.MedcardToken) || '',
    }

    if (familyProfileUuid) {
      headers['Family-Profile-Uuid'] = familyProfileUuid
    }

    return infoClient.get<HealthDiaryStateDTO>(`${RESOURCE}/state/`, {
      camelize: true,
      headers,
    })
  },
}
